<template>
    <table class="statistica__open-position-table">
        <tr class="statistica__open-position-item-data__sub-title">
            <td class="statistica__open-position-item-data__sub-title-number">номер</td>
            <td class="statistica__open-position-item-data__sub-title-time-open">время открытия</td>
            <td class="statistica__open-position-item-data__sub-title-type">тип</td>
            <td class="statistica__open-position-item-data__sub-title-volume">объем</td>
            <td class="statistica__open-position-item-data__sub-title-price">цена</td>
            <td class="statistica__open-position-item-data__sub-title-tp">T/P</td>
            <td class="statistica__open-position-item-data__sub-title-sl">S/L</td>
            <td class="statistica__open-position-item-data__sub-title-pl">P/L, $</td>
            <td class="statistica__open-position-item-data__sub-title-pl-percent">P/L, %</td>
            <td class="statistica__open-position-item-data__sub-title-pl-pips">P/L, p</td>
        </tr>
        <tr class="statistica__open-position-item-data__sub" v-for = "(items, index) in pair" :key = "index">
            <td class="statistica__open-position-item-data__sub-number">{{items.id}}</td>
            <td class="statistica__open-position-item-data__sub-time-open">{{$datef(items.timeEnter)}}</td>
            <td class="statistica__open-position-item-data__sub-type"
                :class = "(items.side == -1) ? 'color-red' : 'color-green'">{{(items.side == -1) ? 'SELL' : 'BUY'}}</td>
            <td class="statistica__open-position-item-data__sub-volume">{{items.volume}}</td>
            <td class="statistica__open-position-item-data__sub-price">{{items.priceEnter}}</td>
            <td class="statistica__open-position-item-data__sub-tp">{{items.tp}}</td>
            <td class="statistica__open-position-item-data__sub-sl">{{items.sl}}</td>
            <td class="statistica__open-position-item-data__sub-pl"
                :class = "(items.resultDepo < 0) ? 'color-red' : 'color-green'">{{items.resultDepo}}</td>
            <td class="statistica__open-position-item-data__sub-pl-percent"
                :class="(getPercentPl(items.resultDepo) < 0) ? 'color-red' : 'color-green'">{{$moneyf(getPercentPl(items.resultDepo),5)}}</td>
            <td class="statistica__open-position-item-data__sub-pl-pips"
                :class = "(items.resultPoint < 0) ? 'color-red' : 'color-green'">{{items.resultPoint}}</td>
        </tr>
    </table>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: {
        pair: {default:[]}
    },
    computed: {
        ...mapGetters ({
            getCropStat: 'accountstat/getCroppedStatBySymbol'
        }),
    },
    methods: {
        getPercentPl(resultDepo) {
            if(typeof this.getCropStat('') === 'undefined')
                return 0;
            let pl = resultDepo/this.getCropStat('').Summary.Equity*100
            return pl;
        }
    },
};

</script>
<style lang="less" scoped>
table.statistica__open-position-table {
    width:100%;
}
.statistica__open-position-item-data__sub-title {
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 3.64;
    letter-spacing: 0.4px;
    color: #adc7e1;
    text-transform: uppercase;
    text-align: right;
    background-color: #3d536b;
    border-bottom: 1px solid #374b62;
    &-number {
        width: 76px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-time-open{
        width: 156px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-type {
        width: 76px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: center;
    }

    &-volume {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-price {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-tp {
        width: 71px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-sl {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-pl {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-pl-percent {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-pl-pips {
        width: 55px;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 12px;
    }

    &-maxdd {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-ico {
        width: 36px;
        box-sizing: border-box;
    }
}

.statistica__open-position-item-data__sub {
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.5;
    letter-spacing: 0.4px;
    text-align: right;
    color: #ffffff;
    background-color: #3d536b;
    border-bottom: 1px solid #374b62;

    &-number {
        width: 76px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-time-open {
        width: 156px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-type {
        width: 76px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: center;
    }

    &-volume {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-price {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-tp {
        width: 71px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-sl {
        width: 73px;
        box-sizing: border-box;
        padding-left: 12px;
        text-align: left;
    }

    &-pl {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-pl-percent {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-pl-pips {
        width: 55px;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 12px;
    }

    &-maxdd {
        width: 86px;
        box-sizing: border-box;
        padding-left: 12px;
    }

    &-ico {
        width: 36px;
        box-sizing: border-box;
        text-align: left;
        padding-left: 12px;
        color: #adc7e1;
    }

}
</style>